import React, {useEffect, useState, useRef} from 'react';
import {View, StyleSheet, Platform, Dimensions} from 'react-native';
import {getTableauWorkbooks} from '@/Hooks/LoginApi/loginApi';
import Box from '@/Atoms/Box';
import CCText from '@/Atoms/CCText';
import CCButton from '@/Atoms/CCButton';
import CCColors from '@/Utils/CCColors';
import Spacer from '@/Atoms/Spacer';
import {FontSizes, vs} from '@/Utils/Dimensions';
import Loader from '@/Atoms/CCLoader/CCLoader';
import CCSelect from '@/Atoms/CCSelect';
import SubscriptionModal from '../Subscription/components/Modals';
import {getLocalStorage, setLocalStorage} from '@/Utils/CommonUtils';
import dayjs from 'dayjs';
import {useNonPersistedUserPlanStore} from '@/Store/userPlanStore';
import SupersetReport from './components/Superset/SupersetReport';
import ENV from '../../../environment';

const {SUPERSET_URL, SUPERSET_USERNAME, SUPERSET_PASSWORD} = ENV;

const Reports = ({dashboardData}) => {
  const userData = dashboardData.user;
  //console.log('userData', userData);
  // const [currentView, setCurrentView] = useState<string>('');
  // const [reportLoading, setReportLoading] = useState<boolean>(false);
  const [reportConfig, setReportConfig] = useState<any>();
  const [supersetWorkbooks, setSupersetWorkbooks] = useState<any>([]);
  const [selectedSupersetWorkbook, setSelectedSupersetWorkbook] =
    useState<any>();
  const [selectedSupersetReport, setSelectedSupersetReport] =
    useState<string>('');

  const [limitType, setLimitType] = useState('');
  const [usageLimit, setUsageLimit] = useState(0);
  const [planName, setPlanName] = useState('');
  const {subscriptionModalOpen, setSubscriptionModalOpen} =
    useNonPersistedUserPlanStore();
  const [loading, setLoading] = useState<boolean>(false);

  const getSupersetWorkBooks = (): Array<{
    id: string;
    workBookName: string;
    views: {supersetEID: string; name: string}[];
  }> => {
    return [
      {
        id: '1',
        workBookName: 'PlayerPerformance',
        views: [
          {
            supersetEID: 'f6f60946-e95a-4614-b04d-dcec269e9d1a',
            name: 'Rating Performance',
          },
          {
            supersetEID: '10c70e0c-ca3a-45ab-b942-93c3a4af19ae',
            name: 'Time Pressure',
          },
          {
            supersetEID: 'bb1e5647-7934-4682-8b7f-5bad42120e57',
            name: 'Opening Analysis',
          },
          {
            supersetEID: 'b48d53a6-c720-4ac5-b338-7fd0f79265d9',
            name: 'Endgame Analysis',
          },
          {
            supersetEID: '2ae612a7-cbdf-416a-926f-da29569c465d',
            name: 'Report Card',
          },
          // {
          //   supersetEID: '870361d7-16eb-4594-9c3f-09f81ddcfd86',
          //   name: 'Dashboard1',
          // },
          // {
          //   supersetEID: '5bcba20a-b590-471d-94d5-2a95223246a4',
          //   name: 'Dashboard2',
          // },
        ],
      },
      //Can be added like this in future
      // {
      //   id: '2',
      //   workBookName: 'PlayerPerformance',
      //   views: [
      //     {
      //       supersetEID: 'c0e9366d-605e-4709-884c-954f32f3b254',
      //       name: 'Prod_Dashboard_test',
      //     },
      //     {
      //       supersetEID: 'dd2c461e-7e7d-49f2-98d2-59fb7ace1679',
      //       name: 'Prod_Dashboard_test2',
      //     },
      //     {
      //       supersetEID: '47b0ae91-511c-415c-92e2-38f7917fd127',
      //       name: 'Staging_Dashboard_test',
      //     },
      //     {
      //       supersetEID: '55f571d8-1193-4250-86d9-9b81e587850d',
      //       name: 'CC_Test_Dashboard',
      //     },
      //     {
      //       supersetEID: 'd1796301-189e-4c39-89e8-f326ccd4e39f',
      //       name: 'Dashboard1',
      //     },
      //     {
      //       supersetEID: '699368e3-57a4-450d-8d35-3908b2d3ee36',
      //       name: 'Dashboard2',
      //     },
      //   ],
      // },
      // {
      //   id: '3',
      //   workBookName: 'Name2',
      //   views: [
      //     {
      //       supersetEID: '7e61298b-0a0f-48d5-a9a8-11e0e0cfd163',
      //       name: 'Dashboard3',
      //     },
      //     {
      //       supersetEID: '1af1f667-11f5-42b6-900a-83587d85237b',
      //       name: 'Dashboard4',
      //     },
      //   ],
      // },
    ];
  };

  useEffect(() => {
    const workbooks = getSupersetWorkBooks();
    setSupersetWorkbooks(workbooks);
    if (workbooks.length > 0) {
      setSelectedSupersetWorkbook(workbooks[0]);
      changeView(workbooks[0], workbooks[0].views[0]);
    }
  }, []);

  const changeView = async (workBookName, view) => {
    if (loading) return;
    setSelectedSupersetReport(view.supersetEID);
    setLoading(true);

    setTimeout(() => setLoading(false), 2000);
  };

  const handleWorkbookChange = (values: string[]) => {
    const id = values[0];
    const supersetWorkbook = supersetWorkbooks.find(w => w.id === id);
    if (supersetWorkbook && supersetWorkbook.views?.length > 0) {
      setSelectedSupersetWorkbook(supersetWorkbook);
      setSelectedSupersetReport('');
      // const view = supersetWorkbook.views[0];
      // changeView(supersetWorkbook.workBookName, view);
    }
  };

  const planMessage = `${limitType} limit of ${usageLimit} ${
    usageLimit === 1 ? 'report' : 'reports'
  } is exhausted. Upgrade now to continue with detailed report.`;

  return (
    <View style={styles.container}>
      <Loader
        loading={loading}
        bgWhite={true}
        textToShow="Breaking Down Your Stats"
        textColor={CCColors.TextColor.Dark}
      />
      <View style={[styles.container2, {flexDirection: 'row'}]}>
        <Box flexDirection="row" flex={1} margin={3} overflow="hidden">
          <View style={styles.container3}>
            <CCText
              color={CCColors.TextColor.Dark}
              textAlign={'center'}
              fontSize={FontSizes[24]}>
              Select a Workbook
            </CCText>
            <View style={styles.dropdown}>
              <CCSelect
                key={selectedSupersetWorkbook?.id}
                ccSelectHeight={45}
                ccSelectWidth="100%"
                singleSelectDropdown={true}
                placeholder={
                  selectedSupersetWorkbook?.workBookName || 'Select a Workbook'
                }
                selectedValue={selectedSupersetWorkbook?.id}
                onValueChange={handleWorkbookChange}
                items={supersetWorkbooks?.map(supersetWorkbook => ({
                  label: supersetWorkbook.workBookName,
                  value: supersetWorkbook.id,
                }))}
              />
            </View>

            {!selectedSupersetReport && selectedSupersetWorkbook && (
              <>
                <Spacer spacing={vs(20)} />
                <CCText
                  textAlign={'center'}
                  fontSize={FontSizes[14]}
                  color={CCColors.TextColor.Dark}
                  // color={CCColors.TextColor.GreyText}
                >
                  Select a Dashboard
                </CCText>
              </>
            )}
            <Spacer spacing={vs(20)} />
            <View style={styles.button}>
              {selectedSupersetWorkbook?.views?.map(view => (
                <CCButton
                  type="box"
                  style={{
                    marginBottom: 10,
                    borderColor: CCColors.Border,
                    borderBottomColor: CCColors.Border,
                    borderLeftWidth:
                      selectedSupersetReport === view.supersetEID ? 5 : 1,
                    width: '100%',
                    height: 40,
                    borderLeftColor:
                      selectedSupersetReport === view.supersetEID
                        ? CCColors.Primary.Default
                        : CCColors.Border,

                    backgroundColor:
                      selectedSupersetReport === view.supersetEID
                        ? CCColors.Primary.lightYellow
                        : CCColors.White,
                  }}
                  hoverEffect={false}
                  key={view.supersetEID}
                  titleStyle={{color: CCColors.TextColor.Dark}}
                  onPress={() =>
                    changeView(selectedSupersetWorkbook.workBookName, view)
                  }>
                  <CCText textAlign={'center'} fontSize={FontSizes[12]}>
                    {view.name}
                  </CCText>
                </CCButton>
              ))}
            </View>
          </View>

          <View />
          {/* <View style={styles.webview} id="tableauViz" /> */}
        </Box>
        <View style={styles.webview}>
          {selectedSupersetReport && (
            <SupersetReport
              dashboardId={selectedSupersetReport}
              userData={userData}
            />
          )}
        </View>
        {/* <View style={[styles.webview, {flexDirection: 'column'}]} /> */}
      </View>

      <SubscriptionModal
        visible={subscriptionModalOpen}
        onClose={() => setSubscriptionModalOpen(false)}
        user={dashboardData?.user}
        planMessage={planMessage}
        currentPlan={planName}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexWrap: 'wrap',
    backgroundColor: CCColors.Primary.Light,
  },
  container2: {
    flex: 1,
  },
  container3: {
    flex: 1,
    alignContent: 'center',
    padding: 10,
  },
  webview: {
    flex: 3.2, //adjust if needed
  },
  button: {
    width: '100%',
    flex: 1,
    alignContent: 'center',
    padding: 10,
    flexShrink: 1, // allows text to shrink if needed
    flexWrap: 'wrap',
  },
  dropdown: {
    width: '100%',
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    zIndex: 1002,
    marginHorizontal: 'auto',
  },
});
export default Reports;
